import apiClient from "../utils/axiosUtil";

export const getNews = async () => {
    try {
        return await apiClient.get('/public/getNews');
    } catch (error) {
        console.error("Error fetching news:", error);
        throw error;
    }
}
